import { PozSubscriptionBillingPeriod } from './poz-subscription';

export class SubscriptionConfig {
  defaultProductSubscription?: number;
  defaultBillingPeriod: PozSubscriptionBillingPeriod =
    PozSubscriptionBillingPeriod.MONTHLY;
  showQuantity: boolean = false;
  generateInvoice?: boolean = true;
}
